import { API_VERSIONS } from './apiVersions.config';

function hasOwnKey<X extends {}, Y extends PropertyKey>(obj: X, key: Y): obj is X & Record<Y, unknown> {
    return Object.prototype.hasOwnProperty.call(obj, key);
}

export function getBaseUrl(apiVersion: string): string | null {
    if (!hasOwnKey(API_VERSIONS, apiVersion)) {
        return null;
    }

    const value = API_VERSIONS[apiVersion];
    if (typeof value !== 'string') {
        return null;
    }

    return value;
}
